// import { log } from 'util';
import Vue from 'vue'
import http from './ajax.js'
import popup from './popup';
const browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Firefox') > -1, //火狐内核Gecko
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android
      iPhone: u.indexOf('iPhone') > -1, //iPhone
      iPad: u.indexOf('iPad') > -1, //iPad
      webApp: u.indexOf('Safari') > -1, //Safari
      user: u,
    };
  }()
}
// 随机id当做设备标识
function randomRangeId(num = 8) {
  var returnStr = "",
    charStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < num; i++) {
    var index = Math.round(Math.random() * (charStr.length - 1));
    returnStr += charStr.substring(index, index + 1);
  }
  localStorage.setItem("device_no", returnStr);
  return returnStr;
};
if (!localStorage.getItem('device_no')) {
  randomRangeId();
}
var tools = ((Vue) => {
  return {
    pageLayout: "total,sizes,prev,pager,next,jumper",
    ios:browser.versions.ios,
    //微信
    isWeiXin: function () {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    // 产品历史费率tab是否显示
    showFeeHistory() {
      const userInfo = this.getLocal('userinfo');
      // mechanCode 下级机构及员工包含父级机构code
      if(userInfo.mechanCode.includes('bz0240202049')) {
        // bz0240202049 上海悠芊树网络科技有限公司
        return false
      } else if(userInfo.mechanCode.includes('bz0231226602') && userInfo.level != 1) {
        // bz0231226602 陕西汇鑫保呗企业管理咨询有限公司
        return false
      }
      return true
    },
    // 对特定账号隐藏相关信息
    hiddeForAccount(hideAccount) {
      let data = localStorage.getItem('userinfo')
      var dataObj = JSON.parse(data);
      var dataObjDatatoJson = !dataObj ? null : dataObj.data;
      let account = dataObjDatatoJson.account
      if (account == hideAccount) {
        return true
      }
      return false
    },
    //判断是数组
    isArray(o) {
      return Object.prototype.toString.call(o) == '[object Array]';
    },
    //判断null
    isNull: function (exp) {
      if (!exp && typeof exp != "undefined" && exp != 0) {
        return true;
      } else if (exp == "null") {
        return true;
      }
      return false;
    },
    //删除地址栏参数
    delQueStr: function (url, ref) {
      var str = "";
      if (url.indexOf('?') != -1) {
        str = url.substr(url.indexOf('?') + 1);
      } else {
        return url;
      }
      var arr = "";
      var returnurl = "";
      var setparam = "";
      if (str.indexOf('&') != -1) {
        arr = str.split('&');
        let i;
        for (i in arr) {
          if (arr[i].split('=')[0] != ref) {
            returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
          }
        }
        return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
      } else {
        arr = str.split('=');
        if (arr[0] == ref) {
          return url.substr(0, url.indexOf('?'));
        } else {
          return url;
        }
      }
    },
    //获取cookie
    getcookie: function (name) {
      var strcookie = document.cookie;
      var arrcookie = strcookie.split("; ");
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) return decodeURIComponent(arr[1]);
      }
      return "";
    },
    //设置本地储存
    setLocal: function (name, value, type) {
      var curTime = new Date().getTime();
      if (!type || type == 2) { //默认设置-之前存在则使用创建时间
        var data = localStorage.getItem(name);
        if (!data || data == "null") {
          localStorage.setItem(name, JSON.stringify({
            data: value,
            time: curTime
          }));
        } else {
          var dataObj = JSON.parse(data);
          var setTime = dataObj.time;
          localStorage.setItem(name, JSON.stringify({
            data: value,
            time: setTime
          }));
        }
      } else if (type == 1) { //type:1重新创建
        localStorage.setItem(name, JSON.stringify({
          data: value,
          time: curTime
        }));
      }

    },
    //获取本地储存
    getLocal: function (name, exp) {
      var data = localStorage.getItem(name);
      var dataObj = JSON.parse(data);
      var dataObjDatatoJson = !dataObj ? null : dataObj.data;
      return dataObjDatatoJson;
    },
    //设置本地储存Session
    setSession: function (name, value, type) {
      var curTime = new Date().getTime();
      if (!type || type == 2) { //默认设置-之前存在则使用创建时间
        var data = sessionStorage.getItem(name);
        if (!data || data == "null") {
          sessionStorage.setItem(name, JSON.stringify({
            data: value,
            time: curTime
          }));
        } else {
          var dataObj = JSON.parse(data);
          var setTime = dataObj.time;
          sessionStorage.setItem(name, JSON.stringify({
            data: value,
            time: setTime
          }));
        }
      } else if (type == 1) { //type:1重新创建
        sessionStorage.setItem(name, JSON.stringify({
          data: value,
          time: curTime
        }));
      }

    },
    //获取本地储存Session
    getSession: function (name, exp) {
      var data = sessionStorage.getItem(name);
      var dataObj = JSON.parse(data);
      if (!exp) {
        var exp = 1000 * 60 * 60 * 24 * 3;
      }
      if (dataObj && new Date().getTime() - dataObj.time > exp) {
        sessionStorage.removeItem(name);
        return null;
      } else {
        var dataObjDatatoJson = !dataObj ? null : dataObj.data;
        return dataObjDatatoJson;
      }
    },
    getall: function (callback) {
      var that = this;
      if (this.getLocal('all')) {
        callback(this.getLocal('all'))
      } else {
        http({
          url: '/sys/dic/read/all',
          type: 'get'
        }).then(function (data, err) {
          that.setLocal('all', data.data)
          callback(data.data)
        });
      }
    },
    downloadImg(imgsrc) {
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = imgsrc.substring(imgsrc.lastIndexOf("/") + 1); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    // 对象转为url参数， urlEncode(param)
    urlEncode(data, isPrefix) {
      isPrefix = isPrefix ? isPrefix : false
      let prefix = isPrefix ? '?' : ''
      let _result = []
      for (let key in data) {
        let value = data[key]
        // 去掉为空的参数
        if (['', undefined, null].includes(value)) {
          continue
        }
        if (value.constructor === Array) {
          value.forEach(_value => {
            _result.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(_value))
          })
        } else {
          _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
        }
      }
      return _result.length ? prefix + _result.join('&') : ''
    },
    // 时间处理
    formatDate(date, fmt = "yyyy-MM-dd") {
      if (!date) {
        return "";
      }
      // debugger
      if (typeof date == "string") {
        date = date.replace(/-/g, "/") // 解决safari浏览器时间格式不兼容的问题
      }
      date = new Date(date);
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    },
    // 下载二维码
    dataToBlob(name, data) {
      data = data.split(',')[1];
      data = window.atob(data);
      var ia = new Uint8Array(data.length);
      for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      };
      var blob = new Blob([ia], {
        type: "image/jpeg"
      });
      const href = window.URL.createObjectURL(blob)
      const downloadElement = document.createElement('a')
      downloadElement.href = href
      downloadElement.download = name + '.jpg' // 下载后的文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 下载
      document.body.removeChild(downloadElement) // 下载完成 移除 a
      window.URL.revokeObjectURL(href) // 释放blob对象
      // var fd = new FormData();
      // fd.append('img', blob,'.png');
      // this.upload(fd)
    },
    daochuJump(url, params) {
      const loading = popup.loading();
      if (params) {
        if (url.includes("?")) {
          url = url + "&" + this.urlEncode(params)
        } else {
          url = url + "&" + this.urlEncode(params)
        }
      }
      location.href = url;
      setTimeout(() => {
        loading.close();
      }, 2000)
    },
    // 导出文件 url接口地址
    daochu(url, params, type = 'get') {
      const loading = popup.loading("文件正在下载，请稍等片刻");
      http({
        url: url,
        forced: true,
        responseType: "blob",
        All: true,
        params: params,
        type: type
      }).then((res) => {
        this.daochuDownload(res);
      }).finally(() => {
        loading.close();
      });
    },
    // fileUrl文件地址
    daochu2(fileUrl, fileName) {
      const loading = popup.loading("文件正在下载，请稍等片刻");
      http({
        url: fileUrl,
        forced: true,
        responseType: "blob",
        All: true,
        params: {},
        type: 'get'
      }).then((res) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(res.data);
        a.href = url;
        a.download = fileName || (fileUrl.substring(fileUrl.lastIndexOf("/") + 1));
        a.click();
        window.URL.revokeObjectURL(url);
      }).finally(() => {
        loading.close();
      });
    },
    daochuDownload(res) {
      try{
        const fileName = decodeURI(
          res.headers["content-disposition"].split(";").pop().split("filename=")[1].replace(/"/g, "")
        );
        // const fileName = this.detailInfo.name + ".xls";
        const blob = new Blob([res.data]); //构造一个blob对象来处理数据
        // const fileName = "xx.xls";
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ("download" in document.createElement("a")) {
          //支持a标签download的浏览器
          const link = document.createElement("a"); //创建a标签
          link.download = fileName; //a标签添加属性
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); //执行下载
          // URL.revokeObjectURL(link.href); //释放url
          // document.body.removeChild(link); //释放标签
        } else {
          //其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      } catch (error) {
        popup.msg("下载失败，请稍后重新下载");
      }
    },
    goback() {
      history.go(-1);
    },
    // 最大余额法：解决百分比和不到100%的问题
    //valueList要计算的数组
    //idx要计算数组中值的下表
    //precision百分比保留几位小数
    getPercentValue(valueList, idx, precision) {
      // 判断是否为空
      if (!valueList[idx]) {
        return 0;
      }
      // 求和
      let sum = valueList.reduce(function (acc, val) {
        return acc + (isNaN(val) ? 0 : val);
      }, 0);
      if (sum === 0) {
        return 0;
      }
      // 10的2次幂是100，用于计算精度。
      let digits = Math.pow(10, precision);
      // 扩大比例100，
      let votesPerQuota = valueList.map(function (val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
      });
      // 总数，扩大比例意味的总数要扩大
      let targetSeats = digits * 100;
      // 再向下取值，组成数组
      let seats = votesPerQuota.map(function (votes) {
        return Math.floor(votes);
      });
      // 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
      let currentSum = seats.reduce(function (acc, val) {
        return acc + val;
      }, 0);
      // 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
      let remainder = votesPerQuota.map(function (votes, idx) {
        return votes - seats[idx];
      });
      // 给最大最大的余额加1，凑个占比100%；
      while (currentSum < targetSeats) {
        //  找到下一个最大的余额，给其加1
        let max = Number.NEGATIVE_INFINITY;
        let maxId = null;
        for (let i = 0, len = remainder.length; i < len; ++i) {
          if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
          }
        }
        // 对最大项余额加1
        ++seats[maxId];
        // 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
        remainder[maxId] = 0;
        // 总的也要加1，为了判断是否总数是否相同，跳出循环。
        ++currentSum;
      }
      // 这时候的seats就会总数占比会100%
      return seats[idx] / digits;
    },
    /**
     * 复制链接文本到剪切板
     * @param {*} url 需要复制的链接或者文本
     */
    copyUrl(url) {
      const cInput = document.createElement("input");
      cInput.value = url;
      document.body.appendChild(cInput);
      // 选取文本域内容;
      cInput.select();
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand("Copy");
      popup.success("复制成功");
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    // 16进制色值转换成RGB
    colorRgb (sColor) {
      sColor = sColor.toLowerCase()
      // 十六进制颜色值的正则表达式
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 如果是16进制颜色
      if (sColor && reg.test(sColor)) {
          if (sColor.length === 4) {
              let sColorNew = '#'
              for (let i = 1; i < 4; i += 1) {
                  sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))    
              }
              sColor = sColorNew
          }
          // 处理六位的颜色值
          let sColorChange = []
          for (let i = 1; i < 7; i += 2) {
              sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))    
          }
          sColorChange.push(0.1)
          return 'RGB(' + sColorChange.join(',') + ')'
      }
      return sColor
    },
    async phoneSignature() {
      const deviceNo = localStorage.getItem('device_no');
      const p = new Promise((resolve, reject) => {
        http({
          url: "/master/user/getSignature",
          type: "put",
          params: {},
          headers: {
            deviceNo: deviceNo
          }
        }).then((res) => {
          resolve(res.data)
        });
      });
      const result = await p;
      return result;
    },
    // 添加水印
    waterMark(str){
      //thisScreenWidth = window.innerWidth;
		  //console.log("thisScreenWidth："+thisScreenWidth);
      const id = "waterMark";
      const canvas = document.createElement("canvas");
      canvas.width = "600"
      canvas.height = "300"
      const cans = canvas.getContext("2d");
      if (document.getElementById(id) !== null) {
        document.getElementById("app").removeChild(document.getElementById(id));
      }

      cans.rotate(-20 * Math.PI / 180);
      cans.font = "20px Vedana";
      cans.fillStyle = "rgba(190, 190, 190, 0.36)";
      cans.textAlign = "left";
      cans.textBaseline = "Middle";
      cans.fillText(str, 0, canvas.height / 2);

      var div = document.createElement("div");
      div.id = id;
      div.style.pointerEvents = "none";//避免遮挡
      div.style.top = "0";
      div.style.left = "240px";
      div.style.position = "absolute";
      div.style.zIndex = "10";
      div.style.width = (document.documentElement.scrollWidth-250) + "px";
      div.style.height = "calc(100% - 60px)"
      // div.style.height = (document.documentElement.scrollHeight-30) + "px";
      div.style.background = "url(" + canvas.toDataURL('image/png') + ") left top repeat";
      // document.body.appendChild(div);
      document.getElementById("app").appendChild(div);
      if(this.bingResize){
        return;
      }
      this.bingResize = true;
      let timer = {};
      //监听页面的尺寸变化，动态改变
      window.addEventListener("resize",()=>{
        window.clearTimeout(timer);
        timer = window.setTimeout(()=>{
          this.waterMark(str)
        },1000)
      })
      return id;
    },
    // 手机号掩码
    phoneMask(str){
      // 默认手机号为11位
      if(str){
        let phone = `${str.substring(0,3)}****${str.substr(-4)}`
        return phone
      }else{
        return ''
      }
    },
    formRule: {
      arrRequired(msg = '请输入') {
        return {
          required: true,
          message: msg,
          trigger: 'blur',
          validator(rule, value, callback) {
            if (!value || !value.length) {
              callback(new Error(rule.message));
              return false;
            }
            callback();
            return true;
          }
        };
      },
      required(msg = '请输入', trigger = 'blur') {
        return { required: true, message: msg, trigger };
      },
      str(msg = '请输入',max=99) {
        return { 
          required: true,
          message: msg,
          min:0,
          max:max,
          trigger: 'blur',
          validator(rule, value, callback) {
            if (!value || !value.length || value.length>rule.max) {
              callback(new Error(rule.message));
              return false;
            }
            callback();
            return true;
          } 
        };
      },
      tel(msg = '请输入正确的手机号') {
        return {
          pattern: /^1[1023456789]\d{9}$/,
          message: msg,
          trigger: 'blur'
        };
      },
      idCard(msg = '请输入正确的身份证') {
        return {
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          message: msg,
          trigger: 'blur'
        };
      },
      url(msg = '请输入正确的链接地址') {
        return {
          pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
          message: msg,
          trigger: 'blur'
        };
      },
      number(required = true) {
        return {
            type: 'number',
            message: '输入的类型为数字',
            trigger: 'blur',
            transform(value) {
              return Number(value)
            },
          }
      },
      // 字数规则 isHZ 是否把汉字作2个字符计算
      count(message = '请输入', count = [0, 10],required = true , isHZ) {
        return {
          validator: function (rule, value, callback) {
            if (rule.required && !value) {
              return callback(new Error(rule.message));
            } else if (!rule.required && !value) {
              return callback();
            } else {
              if (isHZ) {
                value = value.replace(/([^\u0000-\u00FF])/g, "**");
              }
              if (value.length >= count[0] && value.length <= count[1]) {
                return callback();
              } else {
                return callback(new Error(rule.message));
              }
            }
          }, required, message, trigger: 'blur'
        };
      },
    },
    // 删除对象空的属性
    delNull(params) {
      for (const key in params) {
        if (Object.hasOwnProperty.call(params, key)) {
          if (params[key] === "" || params[key] === null) {
            delete params[key]
          }
        }
      }
    },
    $httpRequestList:[],
    cancelhttpRequest() {
      this.$httpRequestList.forEach(c => {
          c('取消请求');
      });
      this.$httpRequestList = [];
    },
  }
})();

Vue.prototype.$tools = tools;
// 数字精度计算
// 加法
Number.prototype.add = function(arg){  
  var r1,r2,m;  
  try{r1=this.toString().split(".")[1].length}catch(e){r1=0}  
  try{r2=arg.toString().split(".")[1].length}catch(e){r2=0}  
  m=Math.pow(10,Math.max(r1,r2))  
  return (this.mul(m)+Number(arg).mul(m))/m
} 
//减法
Number.prototype.sub = function (arg){  
  return this.add(-arg);  
}  
//乘法
Number.prototype.mul = function (arg)   {  
  var m=0,s1=this.toString(),s2=arg.toString();  
  try{m+=s1.split(".")[1].length}catch(e){}  
  try{m+=s2.split(".")[1].length}catch(e){}  
  return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)  
}  
//除法
Number.prototype.div = function (arg){  
  var t1=0,t2=0,r1,r2;  
  try{t1=this.toString().split(".")[1].length}catch(e){}  
  try{t2=arg.toString().split(".")[1].length}catch(e){}  
  var len = Math.max(t1,t2);
  r1 = this*Math.pow(10,len)
  r2 = arg*Math.pow(10,len)
  return (r1/r2);  
}
export default tools
